import React from 'react';
import Header from '@/components/Landing/Header';
import InputForm from '@/components/InputForm';
import TopPart from '@/components/Landing/TopPart';
import Footer from '@/components/Landing/Footer';
import Stepper from '@/components/Landing/Stepper';
import ManagmentBlock from '@/components/Landing/ManagmentBlock';

const Landing: React.FunctionComponent = () => (
	<>
		<Header />
		<TopPart />
		<ManagmentBlock />
		<Stepper />
		<InputForm />
		<Footer />
	</>
);

export default Landing;
